export default "__VITE_ASSET__ChEq6GHy__"